const pluralVariant = (count: number): "one" | "other" => (count <= 1 ? "one" : "other");

/** Build a compound i18n key suffix for multiple independent plural counts, e.g. `key_one_other`. */
export const compoundPluralKey = (baseKey: string, ...counts: number[]): string =>
    `${baseKey}_${counts.map(pluralVariant).join("_")}`;
